export default __webpack_public_path__ + "images/exclamation-mark-96.png";